(function() {
    'use strict';

    angular
        .module('app')
        .filter('search', search);

    search.$inject = [];

    function search() {
        return function(items, searchText, category) {
            if (!searchText) return items; // Si no hay búsqueda, devolver todo

            searchText = searchText.toLowerCase();

            return items.filter(function(item) {
                let matchTitle = item.title && item.title.toLowerCase().includes(searchText);
                let matchField = false;

                if (category === "Enfermedades") {
                    matchField = item.microorganism && item.microorganism.toLowerCase().includes(searchText);
                } else if (category === "Alergias") {
                    matchField = item.scientificname && item.scientificname.toLowerCase().includes(searchText);
                } else {
                    matchField = item.microorganism && item.microorganism.toLowerCase().includes(searchText);
                }

                return matchTitle || matchField;
            });
        };
    }
})();
